var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('cs-preloader-overlay', {
    attrs: {
      "loading": _vm.SELF_EMPLOYED_NOTIFICATIONS_LOADING
    }
  }, [_c('div', {
    class: _vm.$style.container
  }, [_c('div', {
    class: _vm.$style.header
  }, [_c('screen-header', {
    attrs: {
      "title": _vm.$t('common.notifications'),
      "is-desktop": _vm.isDesktop
    }
  })], 1), _c('capusta-content', [_vm.notificationsShown ? _vm._l(_vm.notificationList, function (_ref) {
    var createdAt = _ref.createdAt,
        id = _ref.id,
        message = _ref.message,
        status = _ref.status;
    return _c('div', {
      key: "".concat(id, "_").concat(createdAt),
      staticClass: "notification-list"
    }, [_c('notification', {
      attrs: {
        "color-overlay": _vm.notificationColor(status),
        "image-overlay": "self-employed"
      }
    }, [_c('p', [_c('strong', [_vm._v(_vm._s(_vm.$t('fns.of.russia')) + ":")]), _vm._v(" " + _vm._s(message))]), _c('a', {
      staticClass: "button thin clear",
      attrs: {
        "slot": "button",
        "href": "https://lknpd.nalog.ru/messages/notifications",
        "target": "_blank"
      },
      on: {
        "click": function click($event) {
          return _vm.handleClickNotification(id);
        }
      },
      slot: "button"
    }, [_c('span', [_vm._v(_vm._s(_vm.notificationLabel(status)))])])])], 1);
  }) : [_c('div', {
    staticClass: "notification-empty"
  }, [_vm._v(_vm._s(_vm.$t('no.notifications.for.you')))])]], 2)], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }